export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-10">
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block text-xs px-3 py-1 rounded-full bg-accent-100 text-accent-700 font-medium mb-4">
              随时随地 · 掌上吃瓜
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              黑料在线 · 移动端体验
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-5 max-w-md mx-auto lg:mx-0">
              黑料在线移动端完美适配手机浏览器，无需下载任何APP。直接通过手机浏览器访问本站，
              即可享受与电脑端一致的黑料在线观看体验，高清流畅，随时随地在线观看黑料最新爆料。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机端立即体验
              </a>
              <a
                href="#features"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-background-300 text-foreground-700 font-medium rounded-md hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多特色
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="relative w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden bg-background-200 border-4 border-background-300">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20smartphone%20mockup%20displaying%20modern%20entertainment%20news%20app%20interface%20with%20warm%20dark%20theme%2C%20golden%20amber%20accents%2C%20card-based%20layout%2C%20clean%20minimal%20design%2C%20soft%20dramatic%20lighting%2C%20sophisticated%20premium%20look%2C%20isolated%20on%20clean%20background&width=448&height=796&seq=app-mobile-mockup&orientation=portrait"
                alt="黑料在线移动端界面展示"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}